import {useState, useEffect, useRef} from 'react'
import {date} from '@eitje/utils'

export const useInterval = (callback, delay) => {
	const savedCallback = useRef()

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback
	}, [callback])

	// Set up the interval.
	useEffect(() => {
		function tick() {
			savedCallback.current()
		}
		if (delay !== null) {
			const id = setInterval(tick, delay)
			return () => clearInterval(id)
		}
	}, [delay])
}

export const useCountup = ({defaultValue = 0, defaultTime} = {}) => {
	let def = defaultValue

	if (defaultTime) {
		def = date().diff(date(defaultTime), 's')
	}

	const [secondsElapsed, setSeconds] = useState(def)

	useInterval(() => {
		setSeconds(secs => secs + 1)
	}, 1000)

	useEffect(() => {
		if (defaultTime) {
			setSeconds(date().diff(date(defaultTime), 's'))
		}
	}, [defaultTime])

	return secondsElapsed
}

export const useCountdown = totalSeconds => {
	const secondsElapsed = useCountup()
	return totalSeconds - secondsElapsed
}

export const useResettableCountdown = (totalSeconds, resetKey) => {
	const [startTime, setStartTime] = useState(date())
	const [secondsLeft, setSecondsLeft] = useState(totalSeconds)

	useEffect(() => {
		setStartTime(date())
		setSecondsLeft(totalSeconds)
	}, [resetKey, totalSeconds])

	useInterval(() => {
		const elapsed = date().diff(startTime, 's')
		setSecondsLeft(Math.max(0, totalSeconds - elapsed))
	}, 1000)

	return secondsLeft
}
